<div class="editAccountUserShareList">
  @if (!editingUsers && !ppEmailsReadOnly) {
    <section class="editAccountUserShareList__back" (click)="goBack()">
      <pp-icon
        [ppSrc]="EIconPath.ICON_LEFT_MENU_ARROW_BACK"
        class="editAccountUserShareList__backArrow"
        ppColor="primary-950"
        ppClass="setSize18"
      ></pp-icon>
      <span class="editAccountUserShareList__backText">{{
        'back_to_user_&_site_selection' | ppTranslate
      }}</span>
    </section>
  }

  @if (ppShowingError) {
    <pp-add-users-error-box></pp-add-users-error-box>
  }
  @if (warningMessages?.length > 0) {
    <pp-add-users-warning-box></pp-add-users-warning-box>
  }
  @if (ppShowInfoBox) {
    <pp-account-user-modal-edit-warning></pp-account-user-modal-edit-warning>
  }

  @if (!ppSelectedShares) {
    <section class="editAccountUserShareList__users">
      <h6 class="editAccountUserShareList__usersHeader">{{ 'users' | ppTranslate }}</h6>
      <pp-share-edit-email-input
        class="editAccountUserShareList__usersInput"
        [(ppEmailList)]="emailList"
        [ppDisabled]="ppEmailsReadOnly"
        (ppEmailListChange)="setEmailList($event)"
      ></pp-share-edit-email-input>
    </section>
  }

  @if (ppSelectedShares) {
    <section class="editAccountUserShareList__users">
      <h6 class="editAccountUserShareList__usersHeader">{{ 'site' | ppTranslate }}</h6>
      <pp-share-edit-site-display
        class="editAccountUserShareList__usersInput"
        [ppWorkspaceId]="ppSelectedShares[0].workspaceId"
      ></pp-share-edit-site-display>
    </section>
  }

  <section class="editAccountUserShareList__shareHeaders">
    <div class="sharesHeaders__site">{{ (ppSelectedShares ? 'user' : 'site') | ppTranslate }}</div>
    <div class="sharesHeaders__access">
      {{ 'access' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppMobileTooltip]="true"
        [ppOptions]="{ placement: 'right' }"
        [ppSanitize]="false"
        ppTitle="
      <div style='text-align: left'>
        <ul style='padding-left: 0; margin: 0'>
          <li>•	<strong>{{ 'guest' | ppTranslate }}</strong> – {{
          'share_guest_description' | ppTranslate
        }}</li>
          <br/>
          <li>•	<strong>{{ 'normal' | ppTranslate }}</strong> – {{
          'share_normal_description' | ppTranslate
        }}</li>
          <br/>
          <li>•	<strong>{{ 'admin' | ppTranslate }}</strong> – {{
          'share_admin_description' | ppTranslate
        }}</li>
        </ul>
      </div>"
      ></pp-icon>
    </div>
    <div class="sharesHeaders__accessibleTags">
      {{ 'accessible_tags' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'tags_limited_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>
    <div class="sharesHeaders__tags">
      {{ 'tags' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'user_management_tags_AAL_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>
    <div class="sharesHeaders__activity">
      {{ 'activity' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'activity_AAL_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>
    <div class="sharesHeaders__exports">
      {{ 'exports' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'export_AAL_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>

    <div class="sharesHeaders__flags">
      {{ 'flags' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'flag_AAL_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>

    @if (aalRelationshipsFlagEnabled) {
      <div class="sharesHeaders__relationships">
        {{ 'related_point' | ppTranslate }}
        <pp-icon
          [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
          ppColor="inherit"
          ppClass="setSize14"
          class="settingsSection__header-info"
          ppTooltip
          [ppOptions]="{ placement: 'right' }"
          [ppTitle]="'related_point_AAL_description' | ppTranslate"
          [ppMobileTooltip]="true"
        ></pp-icon>
      </div>
    }

    <div>
      {{ 'comments' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppMobileTooltip]="true"
        [ppOptions]="{ placement: 'right' }"
        [ppSanitize]="false"
        ppTitle="
      <div style='text-align: left'>
        <ul style='padding-left: 0; margin: 0'>
          <li>•	<strong>{{ 'hide_comments' | ppTranslate }}</strong> – {{
          'hide_comments_description' | ppTranslate
        }}</li>
          <li>•	<strong>{{ 'view_comments' | ppTranslate }}</strong> – {{
          'view_comments_description' | ppTranslate
        }}</li>
          <li>•	<strong>{{ 'make_comments' | ppTranslate }}</strong> – {{
          'make_comments_description' | ppTranslate
        }}</li>
        </ul>
      </div>"
      ></pp-icon>
    </div>
    <div class="sharesHeaders__customFields_width">
      {{ 'custom_fields' | ppTranslate }}
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO]"
        ppColor="inherit"
        ppClass="setSize14"
        class="settingsSection__header-info"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppTitle]="'custom_field_list_description' | ppTranslate"
        [ppMobileTooltip]="true"
      ></pp-icon>
    </div>
  </section>

  <section class="editAccountUserShareList__shares">
    @if (
      ppSelectedShares?.length > 1 ||
      ppSelectedWorkspaceIds?.length > 1 ||
      selectedWorkspaces?.length > 1
    ) {
      <pp-account-user-modal-shares-list-bulk-share
        [ppShowBulkAccessibleTags]="ppShowBulkAccessibleTags"
        [ppWorkspaceId]="ppSelectedShares?.[0]?.workspaceId || ppSelectedWorkspaceIds?.[0]"
        (ppShowCustomFieldsTable)="showBulkCustomFieldsTable()"
      ></pp-account-user-modal-shares-list-bulk-share>
    }

    @if (ppSelectedShares) {
      @for (selectedShare of ppSelectedShares; track selectedShare; let index = $index) {
        <pp-account-user-modal-shares-list-individual-share
          [ppHasError]="false"
          (ppShowCustomFieldsTable)="showIndividualCustomFieldsTable(selectedShare)"
          [ppShare]="selectedShare"
          (ppShareChange)="updateShare(selectedShare, index)"
        ></pp-account-user-modal-shares-list-individual-share>
      }
    }

    @if (!ppSelectedShares) {
      @for (workspace of selectedWorkspaces; track workspace) {
        @if (!editingUsers || ppSelectedWorkspaceIds.includes(workspace.workspaceId)) {
          <pp-account-user-modal-shares-list-share
            [ppHasError]="workspace.hasError"
            [ppWorkspaceId]="workspace.workspaceId"
            (ppShowCustomFieldsTable)="showCustomFieldsTable(workspace.workspaceId)"
          ></pp-account-user-modal-shares-list-share>
        }
      }
    }
  </section>
</div>
